type LoadingBlockProps = {
  label?: string;
};

export function LoadingBlock({
  label = "Caricamento in corso...",
}: LoadingBlockProps) {
  return (
    <div className="loading-block" role="status" aria-live="polite">
      <div className="loading-spinner" />
      <span>{label}</span>
    </div>
  );
}
